import React from "react";
import PropTypes from "prop-types";
import { Icon } from "antd";

const TONE_TONE = {
    positive: "good",
    neutral: "muted",
    negative: "bad"
};

const COLUMNS = [
    { key: "good", title: "What went well", icon: "like", tone: "good" },
    { key: "bad", title: "Concerns", icon: "warning", tone: "warn" },
    { key: "ugly", title: "Red flags", icon: "alert", tone: "bad" }
];

function Column({ title, icon, tone, items }) {
    return (
        <div className={"cc-tx-col cc-tx-col--" + tone}>
            <div className={"cc-tx-col__head"}>
                <Icon type={icon} />
                {title}
            </div>
            {items && items.length ? (
                <ul className={"cc-tx-col__list"}>
                    {items.map((item, i) => (
                        <li key={i}>{item}</li>
                    ))}
                </ul>
            ) : (
                <div className={"cc-tx-col__empty"}>None noted</div>
            )}
        </div>
    );
}

Column.propTypes = {
    title: PropTypes.string,
    icon: PropTypes.string,
    tone: PropTypes.string,
    items: PropTypes.array
};

/**
 * AI analysis of the verification call: a short summary, the borrower's tone,
 * and a good / concerns / red-flags breakdown.
 */
const TranscriptAnalysis = ({ analysis }) => {
    if (!analysis) {
        return null;
    }
    const { summary, tone, good, bad, ugly } = analysis;
    const items = { good, bad, ugly };
    return (
        <div className={"cc-tx"}>
            <div className={"cc-tx__top"}>
                {summary ? (
                    <div className={"cc-tx__summary"}>
                        <span className={"cc-tx__label"}>
                            <Icon type={"audit"} /> Call summary
                        </span>
                        <p>{summary}</p>
                    </div>
                ) : null}
                {tone && tone.label ? (
                    <div className={"cc-tx__tone"}>
                        <span className={"cc-tx__label"}>Tone</span>
                        <span
                            className={
                                "cc-tx__tonepill cc-tx__tonepill--" +
                                (TONE_TONE[tone.sentiment] || "muted")
                            }
                        >
                            {tone.label}
                        </span>
                    </div>
                ) : null}
            </div>
            <div className={"cc-tx__grid"}>
                {COLUMNS.map(col => (
                    <Column
                        key={col.key}
                        title={col.title}
                        icon={col.icon}
                        tone={col.tone}
                        items={items[col.key]}
                    />
                ))}
            </div>
        </div>
    );
};

TranscriptAnalysis.propTypes = {
    analysis: PropTypes.object
};

export default TranscriptAnalysis;
